import { useEffect, useState } from 'react'
import Head from 'next/head'
import { chakra } from '@chakra-ui/react'
// @ts-ignore
import TawkTo from 'tawkto-react'

import { SchoolsHero } from '@/components/schools-sales/SchoolsHero'
import { UrgencySection } from '@/components/schools-sales/UrgencySection'
import { BenefitsSection } from '@/components/schools-sales/BenefitsSection'
import { SocialProofSection } from '@/components/schools-sales/SocialProofSection'
import { SpecialOfferCTA } from '@/components/schools-sales/SpecialOfferCTA'
import { ComparisonSection } from '@/components/schools-sales/ComparisonSection'
import { FinalCTA } from '@/components/schools-sales/FinalCTA'
import { Footer } from '@/components/home/Footer'
import { navMenus } from '@/lib/constants/navMenuConstants'
import { APP_NAME } from '@/lib/constants/appConstants'

const SchoolsCBTSolution = () => {
  const [triggerNav, setTriggerNav] = useState<boolean>(false)

  const handleScroll = () => {
    const currentScrollY = window.scrollY
    if (currentScrollY > 10) {
      setTriggerNav(false)
    }
    if (currentScrollY < 10) {
      setTriggerNav(true)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [triggerNav])

  useEffect(() => {
    new TawkTo(
      process.env.NEXT_PUBLIC_TAWKTO_PROPERTY_ID,
      process.env.NEXT_PUBLIC_TAWKTO_WIDGET_ID
    )
  }, [])

  return (
    <>
      <Head>
        <title>Prepare Your Students for the CBT Future - {APP_NAME}</title>
        <meta
          name="description"
          content="With WAEC & NECO moving to CBT by 2026, prepare your students now. Get 500 FREE credits and give your school the competitive edge."
        />
        <meta
          name="keywords"
          content="CBT, WAEC, NECO, JAMB, computer based testing, schools, Nigeria, examination preparation"
        />
        <meta
          property="og:title"
          content="Prepare Your Students for the CBT Future"
        />
        <meta
          property="og:description"
          content="WAEC & NECO are transitioning to CBT by 2026. Don't let your students fall behind."
        />
        <meta property="og:type" content="website" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest"></link>

        {/* facebook meta pixel */}
        <script
          dangerouslySetInnerHTML={{
            __html: ` 
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '628784748799051');
fbq('track', 'PageView');
`,
          }}
        />
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=628784748799051&ev=PageView&noscript=1"
/>`,
          }}
        />
      </Head>
      <chakra.main>
        <SchoolsHero triggerNav={triggerNav} menus={navMenus} />
        <UrgencySection />
        <BenefitsSection />
        <SocialProofSection />
        <SpecialOfferCTA />
        <ComparisonSection />
        <FinalCTA />
        <Footer />
      </chakra.main>
    </>
  )
}

export default SchoolsCBTSolution
